import { module } from 'angular';
import ktableComponent from './ktable.component';
import mfSelectItemTreeComponent from './modals/mf-select/mf-select-item-tree.component';
import './ktable.scss';

export default module('app')
	.component('ktable', ktableComponent)
	.component('mfSelectItemTree', mfSelectItemTreeComponent)
	.name;
